import times from 'lodash/times'
import React, { FC } from 'react'
import Skeleton from 'react-loading-skeleton'
import * as css from './ChipListSkeleton.css'

export interface ChipListSkeletonProps {
  count: number
}

const ChipListSkeleton: FC<ChipListSkeletonProps> = ({ count }) => {
  return (
    <div className={css['chip-skeleton-container']}>
      {times(count).map(() => (
        <Skeleton width={100} height={30} style={{ borderRadius: 16, marginTop: 10 }} />
      ))}
    </div>
  )
}

export default ChipListSkeleton
